<template>
    <div v-if="item">
        <div v-if="item.referenciaOrdenVenta || item.referenciaOrdenCompra" class="resumen-block mb-4">
            <div class="resumen-title text-subtitle-2 grey--text text--darken-1 mb-2">Referencia a órdenes</div>
            <div class="resumen-rows">
                <div v-if="item.referenciaOrdenVenta" class="resumen-row">
                    <span class="resumen-label">Orden de venta</span>
                    <span class="resumen-value">{{ item.referenciaOrdenVenta }}</span>
                </div>
                <div v-if="item.referenciaOrdenCompra" class="resumen-row">
                    <span class="resumen-label">Orden de compra</span>
                    <span class="resumen-value">{{ item.referenciaOrdenCompra }}</span>
                </div>
            </div>
        </div>
        <!-- Resumen: subtotal, descuento/recargo, medios de pago, dinero recibido y cambio -->
        <div class="resumen-block mb-4" v-if="item.subtotalConOfertas != null || item.descuentoMonto != null || item.recargoMonto != null || (item.mediosDePago && item.mediosDePago.length) || item.dineroRecibido != null || item.cambioADevolver != null || esPagoOrdenVenta || esPagoOrdenCompra || esReembolsoPagoOrdenVenta || esReembolsoPagoOrdenCompra">
            <div class="resumen-title text-subtitle-2 grey--text text--darken-1 mb-2">Resumen del movimiento</div>
            <div class="resumen-rows">
                <div v-if="item.subtotalConOfertas != null" class="resumen-row">
                    <span class="resumen-label">Subtotal (con ofertas)</span>
                    <span class="resumen-value">${{ (item.subtotalConOfertas || 0).toFixed(2) }}</span>
                </div>
                <div v-if="item.descuento != null && item.descuento > 0" class="resumen-row">
                    <span class="resumen-label">Descuento ({{ item.descuento }}%)</span>
                    <span class="resumen-value" v-if="item.descuentoMonto != null">-${{ (item.descuentoMonto || 0).toFixed(2) }}</span>
                    <span class="resumen-value" v-else>—</span>
                </div>
                <div v-if="item.recargo != null && item.recargo > 0" class="resumen-row">
                    <span class="resumen-label">Recargo ({{ item.recargo }}%)<span v-if="item.recargoNombre" class="text-caption ml-1">({{ item.recargoNombre }})</span></span>
                    <span class="resumen-value" v-if="item.recargoMonto != null">+${{ (item.recargoMonto || 0).toFixed(2) }}</span>
                    <span class="resumen-value" v-else>—</span>
                </div>
                <div v-if="item.precioTotal != null" class="resumen-row resumen-row-total">
                    <span class="resumen-label font-weight-medium">
                        {{
                            esDevolucion
                                ? 'Diferencia a pagar por el cliente'
                                : (esReembolsoPagoOrdenCompra
                                    ? 'Ingreso por reembolso (orden de compra)'
                                    : (esReembolsoPagoOrdenVenta
                                        ? 'Monto del reembolso'
                                        : (esPagoOrdenCompra ? 'Egreso (orden de compra)' : (esPagoOrdenVenta ? 'Monto del pago' : 'Total'))))
                        }}
                    </span>
                    <span class="resumen-value font-weight-bold">${{ resumenPrecioTotalDisplay }}</span>
                </div>
                <template v-if="esPagoOrdenVenta || esReembolsoPagoOrdenVenta || esPagoOrdenCompra || esReembolsoPagoOrdenCompra">
                    <div class="resumen-row" v-if="item.montoPedidoTotal != null">
                        <span class="resumen-label">{{ esPagoOrdenCompra ? 'Total de la orden de compra' : 'Total del pedido' }}</span>
                        <span class="resumen-value">${{ (item.montoPedidoTotal || 0).toFixed(2) }}</span>
                    </div>
                    <div class="resumen-row" v-if="item.montoPagado != null">
                        <span class="resumen-label">
                            {{
                                esReembolsoPagoOrdenCompra
                                    ? 'Recibido en este movimiento'
                                    : (esReembolsoPagoOrdenVenta ? 'Reembolsado en este movimiento' : 'Pagado en este movimiento')
                            }}
                        </span>
                        <span class="resumen-value">${{ (item.montoPagado || 0).toFixed(2) }}</span>
                    </div>
                    <div class="resumen-row" v-if="item.montoPedidoRestante != null">
                        <span class="resumen-label">
                            {{
                                esReembolsoPagoOrdenCompra
                                    ? 'Saldo de la orden luego de este ingreso'
                                    : (esReembolsoPagoOrdenVenta
                                        ? 'Saldo del pedido luego de este reembolso'
                                        : 'Resto a pagar luego de este pago')
                            }}
                        </span>
                        <span class="resumen-value">${{ (item.montoPedidoRestante || 0).toFixed(2) }}</span>
                    </div>
                </template>
                <template v-if="item.mediosDePago && item.mediosDePago.length > 0">
                    <div class="resumen-divider"></div>
                    <div class="resumen-section-label">Medios de pago</div>
                    <div v-for="(p, i) in item.mediosDePago" :key="i" class="resumen-row resumen-row-indent">
                        <span class="resumen-label">{{ p.medio }}</span>
                        <span class="resumen-value">${{ (p.monto || 0).toFixed(2) }}</span>
                    </div>
                </template>
                <template v-if="item.dineroRecibido != null || item.cambioADevolver != null">
                    <div class="resumen-divider"></div>
                    <div v-if="item.dineroRecibido != null" class="resumen-row">
                        <span class="resumen-label">Dinero recibido</span>
                        <span class="resumen-value">${{ (item.dineroRecibido || 0).toFixed(2) }}</span>
                    </div>
                    <div v-if="item.cambioADevolver != null && Number(item.cambioADevolver) > 0" class="resumen-row">
                        <span class="resumen-label">Monto a devolver</span>
                        <span class="resumen-value">${{ (item.cambioADevolver || 0).toFixed(2) }}</span>
                    </div>
                </template>
            </div>
        </div>

        <!-- Productos devueltos (solo en movimientos tipo DEVOLUCION) -->
        <div v-if="esDevolucion && tieneProductosDevueltos" class="mb-6">
            <h4 class="mb-3">
                <v-icon color="orange darken-2" small class="mr-1">mdi-keyboard-return</v-icon>
                {{ $t('devolucion.labels.seccionDevueltos') }}
            </h4>
            <div class="table-fixed-header-wrap">
            <v-data-table
                class="movimiento-show-table"
                fixed-header
                height="380"
                :headers="headersProductosDevueltos"
                :items="item.productosDevueltos"
                hide-default-footer
            >
                <template v-slot:item.nombre="{ item: row }">
                    {{ getProductoNombre(row) }}
                </template>
                <template v-slot:item.marca="{ item: row }">
                    {{ getMarca(row) }}
                </template>
                <template v-slot:item.modelo="{ item: row }">
                    {{ getModelo(row) }}
                </template>
                <template v-slot:item.tamanio="{ item: row }">
                    {{ getTamanio(row) }}
                </template>
                <template v-slot:item.cantidad="{ item: row }">
                    {{ row.cantidad }}
                </template>
                <template v-slot:item.precioUnitario="{ item: row }">
                    ${{ getPrecioUnitarioOriginal(row).toFixed(2) }}
                </template>
                <template v-slot:item.precioTotal="{ item: row }">
                    ${{ (row.precioTotal || 0).toFixed(2) }}
                </template>
                <template v-slot:item.oferta="{ item: row }">
                    <span v-if="tieneOfertaAplicada(row)" class="success--text font-weight-medium">
                        <v-icon x-small>mdi-tag</v-icon>
                        {{ getOfertaDescripcion(row) }}
                    </span>
                    <span v-else class="grey--text">—</span>
                </template>
                <template slot="no-data">
                    <div class="text-center py-4 grey--text">{{ $t('common.noData') }}</div>
                </template>
            </v-data-table>
            </div>
        </div>

        <!-- Productos vendidos / nuevos (itemsCarrito) -->
        <div v-if="tieneItemsCarrito">
            <h4 class="mb-3">
                <v-icon color="primary" small class="mr-1">mdi-cart</v-icon>
                {{ esDevolucion ? $t('devolucion.labels.seccionNuevos') : $t('movimiento.labels.productos') }}
            </h4>
            <div class="table-fixed-header-wrap">
            <v-data-table
                class="movimiento-show-table"
                fixed-header
                height="380"
                :headers="headersProductosVender"
                :items="item.itemsCarrito"
                hide-default-footer
            >
                <template v-slot:item.nombre="{ item: row }">
                    {{ getProductoNombre(row) }}
                </template>
                <template v-slot:item.marca="{ item: row }">
                    {{ getMarca(row) }}
                </template>
                <template v-slot:item.modelo="{ item: row }">
                    {{ getModelo(row) }}
                </template>
                <template v-slot:item.tamanio="{ item: row }">
                    {{ getTamanio(row) }}
                </template>
                <template v-slot:item.cantidad="{ item: row }">
                    {{ row.cantidad }}
                </template>
                <template v-slot:item.precioUnitario="{ item: row }">
                    ${{ getPrecioUnitarioOriginal(row).toFixed(2) }}
                </template>
                <template v-slot:item.precioTotal="{ item: row }">
                    <div class="font-weight-bold">
                        ${{ (row.precioFinalLinea != null ? row.precioFinalLinea : row.precioTotal || 0).toFixed(2) }}
                    </div>
                </template>
                <template v-slot:item.oferta="{ item: row }">
                    <span v-if="tieneOfertaAplicada(row)" class="success--text font-weight-medium">
                        <v-icon x-small>mdi-tag</v-icon>
                        {{ getOfertaDescripcion(row) }}
                    </span>
                    <span v-else class="grey--text">—</span>
                </template>
                <template slot="no-data">
                    <div class="text-center py-4 grey--text">{{ $t('common.noData') }}</div>
                </template>
            </v-data-table>
            </div>

            <!-- Resumen de totales (mismo estilo que presupuesto/pedido) -->
            <div class="mt-2">
                <p class="mb-0">
                    <strong>Subtotal (con ofertas):</strong>
                    ${{ (item.subtotalConOfertas || 0).toFixed(2) }}
                </p>
                <p
                    v-if="item.descuento != null && Number(item.descuento) > 0"
                    class="mb-0"
                >
                    <strong>Descuento ({{ item.descuento }}%):</strong>
                    -${{ (item.descuentoMonto || 0).toFixed(2) }}
                </p>
                <p
                    v-if="item.recargo != null && Number(item.recargo) > 0"
                    class="mb-0"
                >
                    <strong>Recargo ({{ item.recargo }}%):</strong>
                    +${{ (item.recargoMonto || 0).toFixed(2) }}
                </p>
                <p class="text-h6 mt-2">
                    <strong>Total:</strong>
                    ${{ (item.precioTotal || 0).toFixed(2) }}
                </p>
            </div>
        </div>

        <!-- Montos (solo para devoluciones) -->
        <div v-if="esDevolucion && (item.montoDevolucion != null || item.montoAdicional != null)" class="mt-4 pt-4 border-t">
            <v-row>
                <v-col cols="12" sm="6" v-if="item.montoDevolucion != null">
                    <div class="info-row">
                        <span class="grey--text">{{ $t('devolucion.labels.montoDevolucion') }}:</span>
                        <strong class="ml-2">${{ (item.montoDevolucion || 0).toFixed(2) }}</strong>
                    </div>
                </v-col>
                <v-col cols="12" sm="6" v-if="item.montoAdicional != null">
                    <div class="info-row">
                        <span class="grey--text">{{ $t('devolucion.labels.montoAdicional') }}:</span>
                        <strong class="ml-2">${{ (item.montoAdicional || 0).toFixed(2) }}</strong>
                    </div>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import { DayjsMixin } from "@dracul/dayjs-frontend";

export default {
    name: 'MovimientoShowData',
    mixins: [DayjsMixin],
    props: {
        item: { type: Object, default: null }
    },
    computed: {
        esDevolucion() {
            return this.item?.tipo === 'DEVOLUCION';
        },
        esPagoOrdenVenta() {
            return this.item?.tipo === 'PAGO_ORDEN_VENTA';
        },
        esPagoOrdenCompra() {
            return this.item?.tipo === 'PAGO_ORDEN_COMPRA';
        },
        esReembolsoPagoOrdenVenta() {
            return this.item?.tipo === 'REEMBOLSO_PAGO_ORDEN_VENTA';
        },
        esReembolsoPagoOrdenCompra() {
            return this.item?.tipo === 'REEMBOLSO_PAGO_ORDEN_COMPRA';
        },
        resumenPrecioTotalDisplay() {
            if (!this.item) return '0.00';
            const t = Number(this.item.precioTotal || 0);
            if (this.esPagoOrdenCompra) return Math.abs(t).toFixed(2);
            if (this.esReembolsoPagoOrdenCompra) return Math.abs(t).toFixed(2);
            return t.toFixed(2);
        },
        tieneProductosDevueltos() {
            return Array.isArray(this.item?.productosDevueltos) && this.item.productosDevueltos.length > 0;
        },
        tieneItemsCarrito() {
            return Array.isArray(this.item?.itemsCarrito) && this.item.itemsCarrito.length > 0;
        },
        headersProductosDevueltos() {
            return [
                { text: this.$t('producto.labels.nombre'), value: 'nombre', sortable: false },
                { text: this.$t('producto.labels.marca'), value: 'marca', sortable: false },
                { text: this.$t('producto.labels.modelo'), value: 'modelo', sortable: false },
                { text: this.$t('producto.labels.tamanio'), value: 'tamanio', sortable: false },
                { text: this.$t('producto.labels.cantidad'), value: 'cantidad', sortable: false },
                { text: this.$t('movimiento.labels.precioUnitario'), value: 'precioUnitario', sortable: false },
                { text: this.$t('movimiento.labels.precioTotal'), value: 'precioTotal', sortable: false },
                { text: this.$t('movimiento.labels.oferta'), value: 'oferta', sortable: false },
            ];
        },
        headersProductosVender() {
            return [
                { text: this.$t('producto.labels.nombre'), value: 'nombre', sortable: false },
                { text: this.$t('producto.labels.marca'), value: 'marca', sortable: false },
                { text: this.$t('producto.labels.modelo'), value: 'modelo', sortable: false },
                { text: this.$t('producto.labels.tamanio'), value: 'tamanio', sortable: false },
                { text: this.$t('producto.labels.cantidad'), value: 'cantidad', sortable: false },
                { text: this.$t('movimiento.labels.precioUnitario'), value: 'precioUnitario', sortable: false },
                { text: this.$t('movimiento.labels.precioTotal'), value: 'precioTotal', sortable: false },
                { text: this.$t('movimiento.labels.oferta'), value: 'oferta', sortable: false },
            ];
        },
    },
    methods: {
        getMarca(row) {
            if (row.producto?.marca?.nombre) return row.producto.marca.nombre;
            return row.productoMarca || '-';
        },
        getModelo(row) {
            if (row.producto?.modelo?.nombre) return row.producto.modelo.nombre;
            return row.productoModelo || '-';
        },
        getTamanio(row) {
            if (row.producto?.tamanio?.tamanio) return row.producto.tamanio.tamanio;
            if (row.productoTamanio) return row.productoTamanio;
            return '-';
        },
        getProductoNombre(row) {
            return row.productoNombre || `${this.getMarca(row)} - ${this.getModelo(row)}`;
        },
        getPrecioUnitario(row) {
            const cant = row.cantidad || 1;
            const total = row.precioFinalLinea != null ? row.precioFinalLinea : (row.precioTotal || 0);
            return cant > 0 ? total / cant : 0;
        },
        /** Precio unitario original (base) para mostrar en la tabla */
        getPrecioUnitarioOriginal(row) {
            if (row.precioBase != null && row.precioBase > 0) return Number(row.precioBase);
            const cant = row.cantidad || 1;
            if (cant > 0 && row.precioBaseLinea != null) return row.precioBaseLinea / cant;
            return row.producto?.precio ?? row.producto?.precioVenta ?? 0;
        },
        getPrecioBaseTotal(row) {
            const precioBase = row.precioBase ?? (row.producto?.precio ?? row.producto?.precioVenta ?? 0);
            const cant = row.cantidad || 1;
            return precioBase * cant;
        },
        tieneOfertaAplicada(row) {
            if (row.oferta && (row.oferta.id || row.oferta.nombre)) return true;
            const precioBaseTotal = this.getPrecioBaseTotal(row);
            const precioTotal = row.precioTotal || 0;
            return precioBaseTotal > 0 && precioBaseTotal > precioTotal;
        },
        getOfertaDescripcion(row) {
            if (!this.tieneOfertaAplicada(row)) return '';
            if (row.ofertaSnapshot && row.ofertaSnapshot.nombre) {
                const monto = row.ofertaSnapshot.descuentoAplicadoMonto;
                return monto != null ? `${row.ofertaSnapshot.nombre} ($${(monto).toFixed(2)})` : row.ofertaSnapshot.nombre;
            }
            if (row.oferta && row.oferta.nombre) return row.oferta.nombre;
            const precioBaseTotal = row.precioBaseLinea != null ? row.precioBaseLinea : this.getPrecioBaseTotal(row);
            const precioTotal = row.precioConOfertas != null ? row.precioConOfertas : (row.precioTotal || 0);
            const descuento = precioBaseTotal - precioTotal;
            const porcentaje = precioBaseTotal > 0 ? ((descuento / precioBaseTotal) * 100).toFixed(0) : 0;
            return `${porcentaje}% OFF ($${descuento.toFixed(2)})`;
        },
        montoDescuentoOfertaLinea(row) {
            const d = Number(row.descuentoAplicadoLinea);
            if (!Number.isNaN(d) && d > 0) return Math.round(d * 100) / 100;
            const base = Number(row.precioBaseLinea) || 0;
            const conOf = Number(row.precioConOfertas);
            if (base > 0 && !Number.isNaN(conOf) && conOf < base - 0.001) {
                return Math.round((base - conOf) * 100) / 100;
            }
            return 0;
        },
    },
};
</script>

<style scoped>
.table-fixed-header-wrap {
    min-height: 0;
}
.movimiento-show-table {
    border-radius: 8px;
    overflow: hidden;
}

.border-t {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.info-row {
    display: flex;
    align-items: center;
}

.resumen-block {
    background: rgba(0, 0, 0, 0.03);
    border-radius: 8px;
    padding: 16px 18px;
    border: 1px solid rgba(0, 0, 0, 0.06);
}

.resumen-title {
    letter-spacing: 0.02em;
    margin-bottom: 10px;
}

.resumen-rows {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.resumen-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    min-height: 20px;
}

.resumen-row-total {
    padding-top: 8px;
    margin-top: 0;
    border-top: 1px dashed rgba(0, 0, 0, 0.12);
}

.resumen-row-indent {
    padding-left: 8px;
}

.resumen-label {
    color: rgba(0, 0, 0, 0.65);
    font-size: 0.875rem;
}

.resumen-value {
    font-size: 0.875rem;
    color: rgba(0, 0, 0, 0.87);
}

.resumen-divider {
    height: 1px;
    background: rgba(0, 0, 0, 0.08);
    margin: 0;
    flex-shrink: 0;
}

.resumen-section-label {
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.8125rem;
    margin: 0;
    min-height: 20px;
    display: flex;
    align-items: center;
}
</style>
